import { request } from '../request'

// 结果插件列表
export interface GetResultPluginList {
  task_id: string | null
  result_id: string | undefined
  keyword: string
  risk_level: number[]
  attack_type: string[]
  supported_platforms: number[] //1 windows 3.linux
  att_ck: string[]
  // 安全设备
  device_import_log_record_id: string[]
  /**依赖环境 */
  depend_envs: string[]
  alert_log: number
  /**拦截状态 */
  status: number[]
  page: number
  limit: number
  tag_ids: string[]
}
export const getResultPluginList = (data: GetResultPluginList) =>
  request('/portal/verify/containerSecurity/resultPluginList', {
    method: 'post',
    data,
  })

// 插件详情
export interface GetResultPluginDetail {
  id: string
  result_id: string
}
export const getResultPluginDetail = (data: GetResultPluginDetail) =>
  request('/portal/verify/containerSecurity/resultPluginDetail', {
    params: {
      ...data,
    },
  })

//  任务信息 任务进度
export interface GetResultInfo {
  result_id: string | null | undefined
  task_id: string | null
}
export const getResultInfo = (data: GetResultInfo) =>
  request('/portal/verify/containerSecurity/resultInfo', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情的att&ck列表
export interface GetDetailAttCkList {
  result_id: string
  task_id: string | null
}
export const getDetailAttCkList = data =>
  request(`/portal/v1/container_security/result/${data.result_id}/attck_list`)

//  任务信息 任务详情环形图
export interface GetResultRingPattern {
  result_id: string
}
export const getResultRingPattern = (data: GetResultRingPattern) =>
  request('/portal/verify/containerSecurity/resultRingPattern', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情攻击防护排名
export interface GetResultDefenseRankings {
  result_id: string
}
export const getResultDefenseRankings = (data: GetResultDefenseRankings) =>
  request('/portal/verify/containerSecurity/resultDefenseRankings', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情危险等级分布
export interface GetResultRiskLevel {
  result_id: string
}
export const getResultRiskLevel = (data: GetResultRiskLevel) =>
  request('/portal/verify/containerSecurity/resultRiskLevel', {
    params: {
      ...data,
    },
  })

//获取攻击类型列表
export const getAttackType = data =>
  request(`/portal/verify/container_security/results/${data.resultId}/attack_type`)

//任务详情获取依赖环境下拉列表
export const getResultDependEnvsOption = (data: GetResultRiskLevel) =>
  request('/portal/verify/containerSecurity/resultDependEnvsOption', { params: data })

//获取详情设备下拉列表
export const getResultDeviceOption = (data: GetResultRiskLevel) =>
  request('/portal/verify/containerSecurity/resultDeviceOption', { params: data })
//获取模板拦截成功率排名
export const getResultTemplateRankings = (data: GetResultRiskLevel) =>
  request('/portal/verify/containerSecurity/resultTemplateRankings', { params: data })

// 树结构标签选项
export const getTagTreeOptions = data =>
  request('/portal/v1/container_security/bind_tag_snapshot_list', { params: data })

// 获取离线日志导入信息
export const getOfflineLogImportInfo = data =>
  request(`/portal/v1/container_security/results/${data.resultId}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogImportRecord = data =>
  request(
    `/portal/v1/container_security/results/${data.resultId}/log_device_import_record/${data.id}`,
    {
      method: 'delete',
    },
  )

// 更新资源拦截状态
export const updateResourceInterceptStatus = data =>
  request(`/portal/verify/containerSecurity/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })
// 查询资源拦截状态
export const getResourceInterceptStatus = data =>
  request(`/portal/verify/containerSecurity/result/intercept_statue_list/${data.id}`, {
    params: data,
  })

// 攻击防护排名
export const getAttackDefenseRanking = data =>
  request(`/portal/v1/container_security/attack_protection_ranking`, { params: data })

// 危险等级分布
export const getRiskLevelDistribution = data =>
  request(`/portal/v1/container_security/risk_level_distribution`, { params: data })

// 用例等级分布
export const getResourceLevelsRanking = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/resource_level_distribution`)

// 模板防护失效率排名
export const getTemplateLoseEfficacyRanking = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/template_statistic`)

// 验证结果分布
export const getVerifyDistribution = data =>
  request(`/portal/v1/container_security/verify_result_distribution`, { params: data })

// 设备防护列表
export const getDeviceProtectionList = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/device_defence`)

// 获取筛选聚合数据
export const getResourceFilterData = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/filter_data`)

// 攻击组织筛选框
export const getAttackOrganizationFilterData = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/apt_list`)

// 模板列表筛选框
export const getTemplateFilterData = data =>
  request(`/portal/v1/container_security/tasks/${data.resultId}/template_list`)

// 取消验证用例列表
export const getCancelValidCaseList = data =>
  request(`/portal/v1/container_security/result/${data.resultId}/cancelValidCaseList`)

// 执行失败用例列表
export const getSentFailedCaseList = data =>
  request(`/portal/v1/container_security/result/${data.resultId}/sentFailedCaseList`)

// 未执行用例列表
export const getUnsentCaseList = data =>
  request(`/portal/v1/container_security/result/${data.resultId}/unsentCaseList`)
